import React from 'react';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { useCallback, useContext, useEffect, useState } from 'react';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import PageWrapper from 'shared/lib/components/containers/pageWrapper';
import SearchBlock from 'shared/lib/components/controls/search/searchBlock';
import PagePaddingWrapper from 'shared/lib/components/containers/pagePaddingWrapper';
import { useTranslation } from 'react-i18next';
import EditSectionModalController from 'widgets/sections/editSectionModalController';
import CreateSectionModalController from 'widgets/sections/createSectionModalController';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import ActionInlineButton from 'shared/lib/components/controls/buttons/actionInlineButton';
import PageInnerContainer from 'pages/components/pageInnerContainer';
import DefaultSectionWidget from 'entities/section/ui/sectionWidget/defaultSectionWidget';
import IconCirclePlus from 'shared/icons/iconCirclePlus';
import SearchFallback from 'pages/searchFallback';

export default observer(function MainPage() {
  const { t } = useTranslation();
  const {
    mobxStore,
    mobxStore: { sectionStore, authStore },
  } = useContext(MobxContext);
  const isAuth = authStore.isAuth;

  const { isLessLaptop, isLessTablet } = useBooleanScreens();

  const [isAddSectionModalOpened, setIsAddSectionModalOpened] =
    useState<boolean>(false);
  const [editSectionId, setEditSectionId] = useState<string | null>(null);
  const editingSection = editSectionId
    ? sectionStore.findSectionById(editSectionId)
    : undefined;

  const handleCloseAddSectionModal = useCallback(
    () => setIsAddSectionModalOpened(false),
    []
  );
  const handleCloseEditSectionModal = useCallback(
    () => setEditSectionId(null),
    []
  );
  const isAdmin = mobxStore.authStore.user?.isAdmin;

  // Обновляем каждый раз оказавшись на главной странице
  const [isFetched, setIsFetched] = useState(false);
  const { isPending, isError } = sectionStore;
  useEffect(() => {
    const foo = async () => {
      if (!isFetched && !isPending && !isError && isAuth) {
        try {
          setIsFetched(true);
          await sectionStore.fetchBulk();
        } catch (e) {
          setIsFetched(false);
          console.error(e);
        }
      }
    };

    foo();
  }, [isPending, isError, sectionStore, isFetched, isAuth]);

  return (
    <>
      <PageWrapper>
        <SearchBlock></SearchBlock>

        <PagePaddingWrapper sx={{ py: 5 }}>
          <SearchFallback>
            <PageInnerContainer
              sx={{
                py: 0,
                alignItems: isLessTablet ? 'center' : 'start',
                gap: 5,
              }}
            >
              {!isAdmin || isLessLaptop ? null : (
                <ActionInlineButton
                  Icon={IconCirclePlus}
                  onClick={() => setIsAddSectionModalOpened(true)}
                >
                  {t('noCategory.createNewSection')}
                </ActionInlineButton>
              )}
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: isLessTablet
                    ? `repeat(1fr)`
                    : 'repeat(2, 1fr)',
                  columnGap: isLessLaptop ? 3 : 5,
                  rowGap: isLessLaptop ? 3 : 5,
                  width: 1,
                }}
              >
                {sectionStore.sections?.map((section) => (
                  <DefaultSectionWidget
                    key={section.id}
                    section={section}
                    onEdit={
                      !isAdmin || isLessLaptop
                        ? undefined
                        : (id) => {
                            setEditSectionId(id);
                          }
                    }
                  ></DefaultSectionWidget>
                ))}
              </Box>
            </PageInnerContainer>
          </SearchFallback>
        </PagePaddingWrapper>
      </PageWrapper>

      <CreateSectionModalController
        key={String(isAddSectionModalOpened)}
        isOpen={isAddSectionModalOpened}
        handleClose={handleCloseAddSectionModal}
        afterSectionCreate={(sectionModel) => {
          sectionStore.localAddSection(sectionModel);
        }}
      ></CreateSectionModalController>

      {editingSection && (
        <EditSectionModalController
          sectionModel={editingSection}
          handleClose={handleCloseEditSectionModal}
          afterSectionDelete={(sectionModel) => {
            sectionStore.localDeleteSections([sectionModel.id]);
          }}
        ></EditSectionModalController>
      )}
    </>
  );
});
